import { Injectable } from '@angular/core';
import {Http, Response} from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class Register {

    constructor (private http: Http) {}

    save(account: any): Observable<any> {
        account.birthDate = new Date(Date.UTC(account.birthDate.getFullYear(), account.birthDate.getMonth(), account.birthDate.getDate()));
        return this.http.post('api/register', account);
    }
    query(): Observable<Response> {
        return this.http.get('api/register');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.service.ts